import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import AddTransactionModal from '../Modals/AddTransaction';
import SuccessToast from '../../toast/SuccessToast';
import { useLanguage } from '../../context/LanguageContext';
import styles from './TransactionOptions.module.css';

// Transaction types configuration
const TRANSACTION_TYPES = [
    {
        id: 1,
        nameKey: 'expense',
        icon: 'minus-circle',
        type: 'expense',
        className: 'transactionExpense',
    },
    {
        id: 2,
        nameKey: 'transfer',
        icon: 'arrow-right',
        type: 'transfer',
        className: 'transactionTransfer',
    },
    {
        id: 3,
        nameKey: 'income',
        icon: 'download',
        type: 'income',
        className: 'transactionIncome',
    },
    {
        id: 4,
        nameKey: 'withdraw',
        icon: 'download-cloud',
        type: 'withdraw',
        className: 'transactionWithdraw',
    },
];

function TransactionOptions({ refreshHome }) {
    const { t } = useLanguage();
    const [showModal, setShowModal] = useState(false);
    const [transactionType, setTransactionType] = useState(null);
    const [showToast, setShowToast] = useState(false);

    // Memoized handlers
    const handleShow = useCallback((type) => {
        setTransactionType(type);
        setShowModal(true);
    }, []);

    const handleClose = useCallback(() => {
        setTransactionType(null);
        setShowModal(false);
    }, []);

    const handleTransactionAdd = useCallback(() => {
        refreshHome();
    }, [refreshHome]);

    const handleLinkClick = useCallback(
        (e, type) => {
            e.preventDefault();
            handleShow(type);
        },
        [handleShow]
    );

    return (
        <section className="categories-section section-b-space">
            <div className="custom-container">
                <ul className="categories-list">
                    {TRANSACTION_TYPES.map((transaction) => (
                        <li key={transaction.id}>
                            <Link
                                to="#"
                                onClick={(e) => handleLinkClick(e, transaction.type)}
                                className={`${styles.transactionLink} ${styles[transaction.className]}`}
                            >
                                <div className={`categories-box ${styles.boxEnhanced}`}>
                                    <i
                                        className="categories-icon"
                                        data-feather={transaction.icon}
                                    ></i>
                                </div>
                                <h5 className={`mt-2 text-center ${styles.transactionLabel}`}>
                                    {t(transaction.nameKey)}
                                </h5>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            {showModal && (
                <AddTransactionModal
                    show={showModal}
                    onClose={handleClose}
                    setShowToast={setShowToast}
                    onTransactionAdd={handleTransactionAdd}
                    transactionType={transactionType}
                />
            )}
            {showToast && (
                <SuccessToast
                    message={t('transactionSuccessful')}
                    onClose={() => setShowToast(false)}
                />
            )}
        </section>
    );
}

export default TransactionOptions;
